import { render, staticRenderFns } from "./screenPedidoLibrosObsequios.vue?vue&type=template&id=6473d120&scoped=true"
import script from "./screenPedidoLibrosObsequios.vue?vue&type=script&lang=js"
export * from "./screenPedidoLibrosObsequios.vue?vue&type=script&lang=js"
import style0 from "./screenPedidoLibrosObsequios.vue?vue&type=style&index=0&id=6473d120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473d120",
  null
  
)

export default component.exports